import React, { Component } from "react";

import image1 from "../../../../images/OMFS/Picture9.png";
import { NavLink } from "react-router-dom";

export class OralMaxilSidebar extends Component {
  render() {
    return (
      <div>
        <div className="widget widget-nav-menu">
          <ul className="widget-menu">
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/OralMaxilPathology"}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/PathologyFaculties"}>
                Faculties and Staff
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/PathologyTeaching"}>
                Teaching - Learning
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/PathologyResearch"}>
                Research and Innovations
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/PathologyActivities"}>
                Activities
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="widget">
          <div className="section-title with-desc text-left clearfix">
            <div className="title-header">
              <h2 className="title">
                Head of the <span>department</span>
              </h2>
            </div>
          </div>

          <div className="ttm_single_image-wrapper mb-35 res-991-mb-20">
            <img className="d-block w-100" src={image1} alt="Dr Ashwin D P" />
          </div>

          <h5 style={{ color: "black" }}>DR. SMITHA T </h5>
          <p>Professor & HOD</p>

          <h6>Education and Qualification:</h6>
          <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
            <li>
              <i className="fas fa-star"></i>
              BDS: JSS Dental College & Hospital, Mysore. (1994 to 1999)
            </li>
            <li>
              <i className="fas fa-star"></i>
              MDS: Vokkaligara Sangha Dental College & Hospital, Bangalore.
              (2003 to 2006)
            </li>
            <li>
              <i className="fas fa-star"></i>
              PhD: Affiliated with RGUHS, Bangalore. (2010 to 2017)
            </li>
          </ul>

          <h6>Work Experience:</h6>
          <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
            <li>
              <i className="fas fa-star" /> Assistant Professor (2006 – 2010)
            </li>
            <li>
              <i className="fas fa-star" /> Associate Professor (2010 – 2016)
            </li>
            <li>
              <i className="fas fa-star" /> Professor (2016 – Till Date)
            </li>
            <li>
              <i className="fas fa-star" /> Professor & HOD (2025 – Till Date)
            </li>
            <li>
              <i className="fas fa-star" /> Total 20 Years of Teaching
              Experience
            </li>
          </ul>
        </div>

        <div className="widget widget-download">
          <h3 className="widget-title">Contact</h3>
          <ul className="download">
            <li>
              <i className="fa fa-phone" />
              <a> 080-22426705</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default OralMaxilSidebar;
